import { StartClient } from "@tanstack/react-start/client";
import { StrictMode, startTransition } from "react";
import { hydrateRoot } from "react-dom/client";

// Custom client entry (overrides @tanstack/react-start's default) so we can
// observe hydration mismatches in production. React only prints readable
// hydration diffs in dev; onRecoverableError fires in prod with the component
// stack of the mismatching subtree. Captured errors are buffered on
// window.__recoverableErrors for inspection (and logged as warnings — not
// console.error, to avoid tripping Lighthouse's errors-in-console audit).
startTransition(() => {
  hydrateRoot(
    document,
    <StrictMode>
      <StartClient />
    </StrictMode>,
    {
      onRecoverableError: (error, errorInfo) => {
        const message = error instanceof Error ? error.message : String(error);
        const componentStack =
          (errorInfo as { componentStack?: string })?.componentStack ?? "";
        const w = window as unknown as {
          __recoverableErrors?: { message: string; componentStack: string }[];
        };
        w.__recoverableErrors = w.__recoverableErrors || [];
        w.__recoverableErrors.push({ message, componentStack });
        console.warn("[hydration:recoverable]", message, componentStack);
      },
    },
  );
});
